export default __webpack_public_path__ + "static/media/mTop_3_c4.bd4fce15.jpeg";